import { render } from "./PartnerFormPage.vue?vue&type=template&id=cb739834&ts=true"
import script from "./PartnerFormPage.vue?vue&type=script&lang=ts"
export * from "./PartnerFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__